module.exports = "<label><input type=\"checkbox\" (change)=\"onSelect($event)\" class=\"checkbox\" [value]=\"value\" [checked]=\"value\" >{{label}}</label>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/controls/checkbox/checkbox.component.html
// module id = ./src/app/shared/components/controls/checkbox/checkbox.component.html
// module chunks = main